// src/components/CityZones.tsx
import React from "react";

type Props = {
  accentHex?: string;
  title?: string;
  highlight?: string;
  subtitle?: string;
  cities?: string[];
  imageSrc?: string;
  imageAlt?: string;
};

const defaultCities = [
  "Medellín",
  "Cali",
  "Barranquilla",
  "Bucaramanga",
  "Pereira",
  "Cartagena",
  "Villavicencio",
  "Armenia",
  "Bogotá Zona 1 ",
  "Bogotá Zona 2",
];

const CityZones: React.FC<Props> = ({
  accentHex = "#E88809",
  title = "Zonas limitadas",
  highlight = "por ciudad",
  subtitle = "Estamos priorizando inversionistas para las siguientes ciudades estratégicas",
  cities = defaultCities,
  imageSrc = "/images/cities-map.png",
  imageAlt = "Camioneta Los Magníficos en plaza de ciudad",
}) => {
  return (
    <section aria-label="Zonas limitadas por ciudad" className="w-full">
      <div className="w-full relative">
        <div className="flex flex-col lg:grid lg:grid-cols-[70%_30%]">
          {/* Columna derecha (imagen) - Mostrar primero en mobile */}
          <div className="relative min-h-[250px] sm:min-h-[300px] lg:min-h-full lg:absolute lg:right-0 lg:top-0 lg:bottom-0 lg:w-[40vw] order-first lg:order-2">
            <img
              src={imageSrc}
              alt={imageAlt}
              className="h-full w-full object-cover"
              loading="lazy"
            />
          </div>

          {/* Columna izquierda (contenido) - Mostrar segundo en mobile */}
          <div
            className="w-full h-full flex items-center justify-center px-4 py-12 sm:py-16 lg:py-24 order-last lg:order-1"
            style={{ backgroundColor: accentHex, paddingLeft: 'clamp(1rem, 4vw, 15rem)', paddingRight: 'clamp(1rem, 2vw, 1rem)' }}
          >
            {/* Más ancho y sin margen derecho */}
            <div className="w-full max-w-3xl text-center sm:text-left">
              <h2
                className="font-extrabold leading-tight text-black lg:whitespace-nowrap"
                style={{ fontSize: 'clamp(1.5rem, 6vw, 3rem)' }}
              >
                <span>{title} </span>
                <span className="text-white">{highlight}</span>
              </h2>

              <p className="mt-2 text-black/90" style={{ fontSize: 'clamp(1rem, 3vw, 1.5rem)' }}>
                {subtitle}
              </p>

              {/* Sección: Ciudades disponibles */}
              <div className="mt-5">
                <div
                  className="flex items-center justify-center sm:justify-start gap-2 text-black font-semibold"
                  style={{ fontSize: 'clamp(1rem, 3vw, 1.5rem)' }}
                >
                  <img 
                    src="/images/icons/ubicación.svg" 
                    alt="Icono ubicación" 
                    className="h-5 w-5 sm:h-6 sm:w-6" 
                  />
                  <span>Ciudades disponibles</span>
                </div>

                {/* Grid de píldoras (más alargadas) */}
                <div className="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-2xl mx-auto sm:mx-0">
                  {cities.map((city) => (
                    <div
                      key={city}
                      className="w-full rounded-2xl bg-black text-white text-center px-6 sm:px-10 py-3 sm:py-4 font-semibold shadow-sm hover:scale-105 hover:-translate-y-2 transition-all duration-300 ease-in-out cursor-pointer hover:shadow-xl"
                      style={{ fontSize: 'clamp(0.9rem, 3vw, 1.5rem)' }}
                    >
                      {city}
                    </div>
                  ))}
                </div>
              </div>

              {/* Tarjeta de atención */}
              <div className="mt-5 max-w-2xl mx-auto sm:mx-0 rounded-xl bg-black/10 border border-black/30 p-4 sm:p-6 hover:scale-105 hover:-translate-y-2 transition-all duration-300 ease-in-out cursor-pointer hover:shadow-xl">
                <div className="flex items-start gap-3">
                  <p className="text-black/90" style={{ fontSize: 'clamp(0.9rem, 3vw, 1.5rem)' }}>
                    <span className="font-semibold">¡Atención!</span> Las zonas
                    son limitadas y se asignan por orden de llegada. No pierdas
                    la oportunidad de ser el primero en tu ciudad.
                  </p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default CityZones;